import React, { Component } from 'react'
import { Provider } from 'react-redux'
import configureStore from '../configureStore'
import AsyncApp from './AsyncApp'
import ReactGA from 'react-ga';
import { BrowserRouter as Router, Switch } from 'react-router-dom'
import { PropsRoute } from 'react-router-with-props';

const store = configureStore()


export default class Root extends Component {
	constructor() {
    super();

    ReactGA.initialize('UA-112857833-1');
    ReactGA.pageview(window.location.pathname);
	}
	componentWillMount () {
		document.title = "Remote Ted - Remote jobs for digital nomads";
	}
	componentDidMount () {
		const script = document.createElement("script");
		script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
		script.async = true;
		document.body.appendChild(script);
		const meta = document.createElement("meta");
		meta.name = "google-site-verification";
		meta.content = "_0lso1nYbmIccotJJoPX0l1oRxOms2gQqmrDhuCC5NE";
		document.head.appendChild(meta);
	}
  render() {
    return (
      <Provider store={store}>
				<Router>
					<Switch>
					<PropsRoute path="/" component={AsyncApp}/>
					<PropsRoute exact path="/javascript" component={AsyncApp}/>
					</Switch>
				</Router>
      </Provider>
    )
  }
}


// WEBPACK FOOTER //
// ./src/containers/Root.js